// Ambient chalk-dust drift — sprinkles a few particle <span>s inside any
// positioned parent. Use inside dark hero / final-CTA sections only. Each
// particle is randomized at mount (horizontal seed, drift direction, delay,
// duration) so the field of dust doesn't look mechanical.
//
// Honors prefers-reduced-motion via the global rule in index.css.
import { useMemo } from "react";

export default function ChalkDust({ count = 18, opacity = 0.55 }) {
  const particles = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      // Deterministic-ish randoms — re-seeding per render is fine since
      // useMemo locks them in for the component's lifetime.
      const left = Math.round(Math.random() * 100);
      const dx = Math.round((Math.random() - 0.5) * 80); // -40..+40 px lateral drift
      const dur = 7 + Math.random() * 6;                  // 7..13s
      const delay = Math.random() * 5;                    // 0..5s stagger
      const size = 2 + Math.round(Math.random() * 3);     // 2..5 px
      const op = opacity * (0.6 + Math.random() * 0.4);   // gentle variation
      return { i, left, dx, dur, delay, size, op };
    });
  }, [count, opacity]);

  return (
    <div className="chalk-dust-layer" aria-hidden="true">
      {particles.map((p) => (
        <span
          key={p.i}
          className="chalk-dust-particle"
          style={{
            left: `${p.left}%`,
            width: p.size, height: p.size,
            "--dust-dx": `${p.dx}px`,
            "--dust-dur": `${p.dur}s`,
            "--dust-delay": `${p.delay}s`,
            "--dust-opacity": p.op,
          }}
        />
      ))}
    </div>
  );
}
